"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testStoreCreator = void 0;
const mock_client_1 = require("./mock-client");
const history_1 = require("history");
const lodash_1 = require("lodash");
/**
 * Generalized mocker for application stores
 */
const testStoreCreator = (createAppStore) => ({ location, initialState = {}, } = {}) => {
    const client = (0, mock_client_1.createMockClient)();
    const history = (0, history_1.createMemoryHistory)();
    if (location) {
        history.push(location);
    }
    const actionEmitters = [];
    const trackAction = () => (next) => (action) => {
        for (const emit of actionEmitters) {
            emit(action);
        }
        next(action);
    };
    const middleware = [trackAction];
    const store = createAppStore({
        client,
        history,
        initialState,
        middleware,
    });
    return Object.assign(Object.assign({}, store), { history,
        trackActions() {
            const _a = trackActions(), { emit } = _a, rest = __rest(_a, ["emit"]);
            actionEmitters.push(emit);
            return rest;
        }, apiClient: client, expectPartialState(state) {
            expect(store.getState()).toMatchObject(state);
        } });
};
exports.testStoreCreator = testStoreCreator;
const trackActions = () => {
    const actions = [];
    return {
        emit(action) {
            actions.push(action);
        },
        expectDispatched(action) {
            const matchingAction = actions.shift();
            if (!(0, lodash_1.isEqual)(matchingAction, action)) {
                throw new Error(`Expected dispatched action ${JSON.stringify(action, null, 2)}, got ${JSON.stringify(matchingAction, null, 2)}`);
            }
        },
    };
};
//# sourceMappingURL=mock-store.js.map